module.exports = __webpack_public_path__ + "media/images/pc/stores/asakusa/asakusa_concept_03-934e569a7aa98615ea0d9f08d219426f.jpg";